/* 
*   Function convert date
*   Arguments
*   1) string - full date
*   2) array  - months
*/
import store from '@/store'
export default function (oldDate) {
    const months    = store.state.blog.months
    const created   = oldDate.split(' ')
    const date      = created[0].split('-')

    const year      = date[0]
    const month     = months.filter((el, idx) => date[1] - 1 === idx)
    const day       = date[2]

    const newDate   = `${day}.${month} ${year}`
    return newDate
}